export type JournalingOptionCategory = 'default' | 'tradingStrategy' | 'tradingConfluence'

const tradingStrategyTranslationKeys: Record<string, string> = {
  'Trend trading': 'tradingStrategies.trendTrading',
  'Range trading': 'tradingStrategies.rangeTrading',
  'Breakout trading': 'tradingStrategies.breakoutTrading',
  'Pullback trading': 'tradingStrategies.pullbackTrading',
  Scalping: 'tradingStrategies.scalping',
  'Day trading': 'tradingStrategies.dayTrading',
  'Swing trading': 'tradingStrategies.swingTrading',
  'Position trading': 'tradingStrategies.positionTrading',
  'Carry trading': 'tradingStrategies.carryTrading',
  'News trading': 'tradingStrategies.newsTrading',
  'Price action trading': 'tradingStrategies.priceActionTrading',
  'Elliott Wave trading': 'tradingStrategies.elliottWaveTrading',
  'Fibonacci trading': 'tradingStrategies.fibonacciTrading',
  'Harmonic pattern trading': 'tradingStrategies.harmonicPatternTrading',
  'Pivot Point trading': 'tradingStrategies.pivotPointTrading',
  'Moving average crossover': 'tradingStrategies.movingAverageCrossover',
  'RSI divergence': 'tradingStrategies.rsiDivergence',
  'MACD crossover': 'tradingStrategies.macdCrossover',
  'Bollinger Bands trading': 'tradingStrategies.bollingerBandsTrading',
  'Ichimoku Cloud trading': 'tradingStrategies.ichimokuCloudTrading',
  'Stochastic Oscillator trading': 'tradingStrategies.stochasticOscillatorTrading',
  'Grid trading': 'tradingStrategies.gridTrading',
  'Martingale trading': 'tradingStrategies.martingaleTrading',
  'Counter-trend trading': 'tradingStrategies.counterTrendTrading',
  'High-frequency trading (HFT)': 'tradingStrategies.highFrequencyTradingHft',
  'Forex signals': 'tradingStrategies.forexSignals',
}

const tradingConfluenceTranslationKeys: Record<string, string> = {
  Support: 'tradingConfluences.support',
  Resistance: 'tradingConfluences.resistance',
  'Supply zone': 'tradingConfluences.supplyZone',
  'Demand zone': 'tradingConfluences.demandZone',
  EMA: 'tradingConfluences.ema',
  'Trend line': 'tradingConfluences.trendLine',
  'Fibonacci retracement': 'tradingConfluences.fibonacciRetracement',
  'Break of structure': 'tradingConfluences.breakOfStructure',
  'Market structure shift (MSS)': 'tradingConfluences.marketStructureShiftMss',
  'Order block': 'tradingConfluences.orderBlock',
  RSI: 'tradingConfluences.rsi',
  MACD: 'tradingConfluences.macd',
  'Moving average crossover': 'tradingConfluences.movingAverageCrossover',
  'Psychological levels': 'tradingConfluences.psychologicalLevels',
  'Volume spike': 'tradingConfluences.volumeSpike',
  'News event': 'tradingConfluences.newsEvent',
  'Price action pattern': 'tradingConfluences.priceActionPattern',
}

export const getJournalingOptionTranslationKey = (
  name: string,
  category: JournalingOptionCategory = 'default',
) => {
  if (category === 'tradingStrategy' && tradingStrategyTranslationKeys[name]) {
    return tradingStrategyTranslationKeys[name]
  }

  if (category === 'tradingConfluence' && tradingConfluenceTranslationKeys[name]) {
    return tradingConfluenceTranslationKeys[name]
  }

  const words = name
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)

  return words
    .map((word, index) => {
      const normalized = word.toLowerCase()

      if (index === 0) {
        return normalized
      }

      return normalized.charAt(0).toUpperCase() + normalized.slice(1)
    })
    .join('')
}
